import colors from './colors';
import { palette, theme } from '@forgeglobal/design-framework';

export const themeOverrides: any = {
  palette: {
    primary: {
      main: colors.primary,
      light: colors.primaryLight,
      dark: colors.primaryDark,
    },
    secondary: {
      main: colors.primary,
    },
  },
  components: {
    MuiRadio: {
      styleOverrides: {
        colorSecondary: {
          color: colors.primary,
          '&:hover': {
            color: colors.primary,
          },
          '&$checked': {
            color: colors.primary,
            '&:hover': {
              color: colors.primary,
            },
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: palette.grey['150'],
          fontWeight: 400,
          color: palette.grey['700'],
          borderRadius: theme.spacing(4),
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        inputAdornedStart: {
          '&:focus': {
            paddingLeft: 0,
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&:first-child': {
            borderTop: '1px solid #E3E8ED',
          },
          '&.Mui-expanded': {
            margin: theme.spacing(0),
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          '&.Mui-expanded': {
            minHeight: 'revert',
          },
        },
        content: {
          '&.Mui-expanded': {
            margin: theme.spacing(1.5, 0),
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          background: theme.palette.background.paper,
          paddingBottom: theme.spacing(1.5),
        },
      },
    },
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            color: theme.palette.grey[700],
          },
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backdropFilter: 'blur(8px)',
        },
        invisible: {
          backdropFilter: 'blur(0px)',
        },
      },
    },
  },
};

export default themeOverrides;
